import { render, staticRenderFns } from "./CustomerCare.vue?vue&type=template&id=0cae2aba"
import script from "./CustomerCare.vue?vue&type=script&lang=js"
export * from "./CustomerCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cae2aba')) {
      api.createRecord('0cae2aba', component.options)
    } else {
      api.reload('0cae2aba', component.options)
    }
    module.hot.accept("./CustomerCare.vue?vue&type=template&id=0cae2aba", function () {
      api.rerender('0cae2aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/CustomerCare.vue"
export default component.exports